export const getDeviceVideosAddresses = (state) =>
  state.devicesVideosReducer?.addresses
